import Mixpanel from "mixpanel-browser";
import { environment } from "./axiosHelpers";

Mixpanel.init("2c0f6ce26f82d1aef81a4ae1bec9aa1d", {
  debug: environment !== "prod",
});

export default Mixpanel;
